import React from 'react';

const ACCENT_STYLES = {
  primary: {
    activeCard: 'border-primary bg-primary/5',
    activeIcon: 'bg-primary text-white',
    activeTitle: 'text-primary',
  },
  secondary: {
    activeCard: 'border-secondary bg-secondary/5',
    activeIcon: 'bg-secondary text-white',
    activeTitle: 'text-secondary',
  },
};

const OptionCard = ({
  icon,
  title,
  description,
  active = false,
  accent = 'primary',
  badge,
  onClick,
  disabled = false,
}) => {
  const styles = ACCENT_STYLES[accent] ?? ACCENT_STYLES.primary;

  return (
    <button
      type='button'
      onClick={onClick}
      disabled={disabled}
      className={`group flex flex-col items-start gap-3 rounded-xl border p-4 text-left transition duration-150 disabled:cursor-not-allowed disabled:opacity-50 ${
        active
          ? `${styles.activeCard} shadow-solid-5`
          : 'border-primary/15 bg-white hover:border-primary/40 hover:bg-background'
      }`}>
      <span
        className={`flex h-11 w-11 items-center justify-center rounded-lg transition duration-150 ${
          active ? styles.activeIcon : 'bg-muted text-muted-foreground'
        }`}>
        {icon}
      </span>
      <span className={`font-semibold ${active ? styles.activeTitle : 'text-primary'}`}>
        {title}
      </span>
      <span className='text-sm text-muted-foreground'>{description}</span>
      {badge && (
        <span className='mt-1 inline-flex items-center rounded-full bg-success/15 px-3 py-1 text-xs font-semibold text-success'>
          {badge}
        </span>
      )}
    </button>
  );
};

export default OptionCard;
